/**
 * Helper to gracefuly handle JSON.parse() exception
 * For some reason, Chrome is fine with exception not handled, but Firefox is not, and will break the UI
 */
export const parseWithoutThrowingException = (json) => {
  if (typeof json !== "string") {
    console.error("Input is not a string:", json);
    return undefined;
  }

  try {
    return JSON.parse(json);
  } catch (e) {
    console.error("Failed to parse json:", json);
    console.error(e);
    return undefined;
  }
};
